import { render } from "./StoreItemCardComponent.vue?vue&type=template&id=193119d8&scoped=true"
import script from "./StoreItemCardComponent.vue?vue&type=script&lang=js"
export * from "./StoreItemCardComponent.vue?vue&type=script&lang=js"

import "./StoreItemCardComponent.vue?vue&type=style&index=0&id=193119d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@4.9.5__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193119d8"]])

export default __exports__